<!-- Search Summary Panel -->
@if (panelSummary) {
    <div class="search-summary-panel" [class]="config.customClasses?.join(' ')">
        <!-- Panel Header with Search Info -->
        <div class="panel-header">
            <div class="search-info">
                <mat-icon class="search-type-icon" [fontIcon]="panelSummary.icon"></mat-icon>

                <div class="search-details">
                    <div class="search-criteria">
                        <!-- Text-based search -->
                        @if (panelSummary.searchType === SearchType.TEXT) {
                            <span class="criteria-text">
                {{ panelSummary.description }}
              </span>
                        }

                        <!-- Location search -->
                        @if (panelSummary.searchType === SearchType.LOCATION) {
                            <span class="criteria-location">
                <span>{{ panelSummary.description }}</span>
              </span>
                        }

                        <!-- Image search -->
                        @if (isImageSearch) {
                            <span class="criteria-image">
                                @if (hasValidImageSrc) {
                                    <button
                                            matButton
                                            class="image-preview-button"
                                            [matTooltip]="imageTooltip"
                                            (click)="openImageDialog(panelSummary.preview!)">
                                  <img crossorigin="anonymous" [src]="panelSummary.preview" alt="Search image preview"
                                       class="image-thumbnail"/>
                                </button>
                                }
                                <span class="image-description">{{ panelSummary.description }}</span>
                              </span>
                        }
                    </div>
                </div>
            </div>
            <div class="spacer"></div>
            <div class="search-panel">
                @if (searchState) {
                    <div class="results-summary">
                        <mat-chip-set class="summary-chips" aria-label="Search results summary">
                            @if (searchState.loading) {
                                <mat-chip class="loading-chip">
                                    <mat-spinner matChipAvatar diameter="16"></mat-spinner>
                                    Loading...
                                </mat-chip>
                            } @else if (searchState.error) {
                                <mat-chip class="error-chip" color="warn">
                                    <mat-icon matChipAvatar>
                                        {{ SearchUtilsService.getErrorIcon(searchState.errorType) }}
                                    </mat-icon>
                                    {{ SearchUtilsService.getErrorTitle(searchState.errorType) }}
                                </mat-chip>
                            } @else {
                                @if (searchState.total > 0) {
                                    <mat-chip class="results-chip">
                                        <mat-icon matChipAvatar fontIcon="dataset"></mat-icon>
                                        {{ searchState.total | number }} result{{ searchState.total === 1 ? "T" : "s" }}
                                    </mat-chip>
                                }
                                @if ( searchState.hasMore) {
                                    <mat-chip
                                            class="more-chip"
                                            [disabled]="searchState.scorePending"
                                            [matTooltip]="searchState.scorePending ? 'Waiting for result ratings to finish loading' : ''"
                                            (click)="!searchState.scorePending && onLoadMore()">
                                        Load more
                                    </mat-chip>
                                } @else if (searchState.results.length > 0 && searchState.results.length < searchState.maxResults) {
                                    <!-- Only when the area ran out of results. Once maxResults is reached the
                                         button is simply hidden, as the user can't load more regardless. -->

                                    <span matTooltip="No more results available in this area">
                                        <mat-chip class="more-chip" [disabled]="true">Load more</mat-chip>
                                    </span>
                                }
                            }
                        </mat-chip-set>
                    </div>
                }
                <!-- Action Buttons -->
                <div class="panel-actions">
                    @if ((searchQueryService.searchDisplayMode$ | async) === SearchDisplayMode.MAP && ((featureFlagsService.getFlags$() | async)?.[FeatureFlags.CUSTOM_ELEMENTS_DETECTION]) && searchState && !searchState.loading && !searchState.error && searchState.results.length > 0 ) {
                        <span [matTooltip]="is3D() ? 'Switch to 2D mode to access Custom Elements.' : 'Run Custom Elements detection on these results'">
                            <button
                                    matIconButton
                                    color="primary"
                                    class="panel-action-button"
                                    [disabled]="is3D()"
                                    (click)="onDetectObjects()">
                                <mat-icon>image_search</mat-icon>
                            </button>
                        </span>
                    }
                    @if (config.showExportButton) {
                        <button
                                matIconButton
                                class="panel-action-button"
                                color="primary"
                                matTooltip="Export search results"
                                (click)="onExport()">
                            <mat-icon>download</mat-icon>
                        </button>
                    }
                    @if (config.showClearButton) {
                        <button
                                matIconButton
                                class="panel-action-button"
                                color="warn"
                                matTooltip="Clear this search "
                                (click)="onClearSearch()">
                            <mat-icon>delete</mat-icon>
                        </button>
                    }
                </div>
            </div>
            <!-- Results Summary -->
        </div>
    </div>
}

<!-- Image Dialog (rendered via CDK Overlay directly on body to escape stacking contexts) -->
<ng-template #imageOverlayTemplate>
    <div class="image-dialog" (click)="$event.stopPropagation()">
        <div class="dialog-content">
            <img crossorigin="anonymous" [src]="selectedImageSrc" alt="Search image" class="full-image"/>
        </div>
    </div>
</ng-template>

